const s = {
  wrapper: {
    minHeight: '100vh',
    background: '#0f1117',
    fontFamily: "'DM Sans', system-ui, sans-serif",
  },
  topBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: '#181c27',
    borderBottom: '1px solid #252a38',
    padding: '0 28px',
    height: '56px',
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  logo: {
    color: '#4f8ef7',
    fontSize: '17px',
    fontWeight: '700',
    letterSpacing: '-0.2px',
  },
  divider: {
    color: '#252a38',
    fontSize: '18px',
    fontWeight: '300',
    userSelect: 'none',
  },
  title: {
    color: '#e2e8f0',
    fontSize: '14px',
    fontWeight: '500',
  },
  signOut: {
    background: 'transparent',
    border: '1px solid #252a38',
    borderRadius: '6px',
    color: '#64748b',
    fontFamily: "'DM Sans', system-ui, sans-serif",
    fontSize: '13px',
    fontWeight: '500',
    padding: '6px 14px',
    cursor: 'pointer',
  },
  content: {
    padding: '32px 28px',
  },
};

export default function AdminLayout({ title, children }) {
  const handleSignOut = () => {
    sessionStorage.removeItem('udanchu_admin_key');
    window.location.reload();
  };

  return (
    <div style={s.wrapper}>
      <div style={s.topBar}>
        <div style={s.left}>
          <span style={s.logo}>Udanchu</span>
          <span style={s.divider}>|</span>
          <span style={s.title}>{title}</span>
        </div>
        <button style={s.signOut} onClick={handleSignOut}>Sign Out</button>
      </div>
      <div style={s.content}>{children}</div>
    </div>
  );
}
